/**
 * Helper function for writing request functions
 */
export function emptyPromise() {
  return new Promise(resolve => resolve([]))
}
